<div class="dx-card padding-content">
    <div class="toolbar">
        <dx-button
            icon="back"
            stylingMode="text"
            hint="กลับไปหน้า Reordering"
            [disabled]="saving"
            (onClick)="backToReordering()"
        ></dx-button>
        <span class="page-title">พักสั่งซื้อระยะยาว ({{ rows.length }})</span>
        <dx-text-box
            mode="search"
            placeholder="ค้นหา SKU ชื่อสินค้า หรือเหตุผล"
            valueChangeEvent="input"
            [width]="300"
            [(value)]="searchText"
        ></dx-text-box>
        <div class="toolbar-spacer"></div>
        <dx-button
            stylingMode="contained"
            icon="refresh"
            hint="Reload data"
            [disabled]="busy"
            (onClick)="load()"
        ></dx-button>
    </div>

    <dx-data-grid
        #dataGrid
        id="longTermPausedGrid"
        height="100%"
        keyExpr="pid"
        [dataSource]="rows"
        [showBorders]="true"
        [showRowLines]="true"
        [rowAlternationEnabled]="true"
        [hoverStateEnabled]="true"
        [allowColumnResizing]="true"
    >
        <!-- Searched from the toolbar's box, on the same row as the title. -->
        <dxo-search-panel [visible]="false" [text]="searchText"></dxo-search-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [pageSize]="50"></dxo-paging>
        <dxo-pager [showInfo]="true"></dxo-pager>
        <dxi-column dataField="sku" caption="SKU" [width]="110"></dxi-column>
        <dxi-column
            dataField="title"
            caption="ชื่อสินค้า"
            [minWidth]="200"
            cellTemplate="titleTemplate"
        ></dxi-column>
        <dxi-column
            dataField="reason"
            caption="เหตุผลที่พัก"
            [width]="360"
        ></dxi-column>
        <dxi-column
            dataField="remain"
            caption="คงเหลือ"
            [width]="90"
            dataType="number"
        ></dxi-column>
        <dxi-column
            caption=""
            [width]="110"
            [allowFiltering]="false"
            [allowSorting]="false"
            alignment="center"
            cellTemplate="restoreTemplate"
        ></dxi-column>
        <div *dxTemplate="let cellData of 'titleTemplate'">
            <a
                [href]="adminProductUrl(cellData.data.pid)"
                target="_blank"
                [title]="cellData.value"
                class="grid-link-ellipsis"
            >
                {{ cellData.value }}
            </a>
        </div>
        <div *dxTemplate="let cellData of 'restoreTemplate'">
            <dx-button
                class="restore-button"
                stylingMode="text"
                text="Restore"
                hint="เอาออกจากรายการพักระยะยาว"
                [disabled]="busy"
                (onClick)="restore(cellData.data)"
            ></dx-button>
        </div>
    </dx-data-grid>
</div>
